// frontend/admin-portal/src/components/settings/StoreIdentityPreview.jsx
import React from "react";
import { useStoreIdentity } from "../../hooks/useStoreIdentity";
import { resolveImageUrl } from "../../services/fileService";

export default function StoreIdentityPreview() {
  const store = useStoreIdentity();

  const logoUrl = store.logo ? resolveImageUrl(store.logo) : "";
  const contactBits = [store.phone, store.email, store.website].filter(Boolean);

  return (
    <div className="fh-store-preview">
      <div className="fh-store-preview__label">
        Preview on invoices & offers
      </div>
      <div className="fh-store-preview__card">
        <div className="fh-store-preview__head">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={store.name}
              className="fh-store-preview__logo"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          ) : (
            <div className="fh-store-preview__logo-placeholder">
              {store.name?.[0]?.toUpperCase() || "F"}
            </div>
          )}
          <div className="fh-store-preview__name-block">
            <div className="fh-store-preview__name">
              {store.name || "Store name"}
            </div>
            {store.legalName && (
              <div className="fh-store-preview__legal">{store.legalName}</div>
            )}
          </div>
        </div>

        {store.address && (
          <div className="fh-store-preview__address">{store.address}</div>
        )}
        {contactBits.length > 0 && (
          <div className="fh-store-preview__contact">
            {contactBits.join(" · ")}
          </div>
        )}
        {store.taxId && (
          <div className="fh-store-preview__tax">Tax ID: {store.taxId}</div>
        )}
      </div>
    </div>
  );
}
